import {mapMutations, mapGetters, mapActions} from "vuex";
import {required, email} from 'vuelidate/lib/validators'

export default {
    name: "password-recovery",
    data() {
        return {
            isRegister: false,
            payload: {
                email: ''
            },
            submitted: false,
            invalidEmail: false,
            showLoader: false
        }
    },
    validations: {
        payload: {
            email: {required, email},
        }
    },
    methods: {
        ...mapMutations({
            changeShowPopUpLogin: 'auth/CHANGE_POPUP_LOGIN',
            changeShowPopUpPasswordRecovery: 'auth/CHANGE_POPUP_PASSWORD_RECOVERY',
            changeShowPopUpPasswordEmail: 'auth/CHANGE_POPUP_PASSWORD_EMAIL',


        }),
        ...mapActions({
            resetPassword: 'auth/RESET_PASSWORD'
        }),

        sendEmail() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                this.showLoader = true
                this.resetPassword(this.payload).then(() => {
                    this.changeShowPopUpPasswordRecovery(false)
                    this.changeShowPopUpPasswordEmail(true)

                }).catch(error => {
                    if (error.status === 422) {
                        this.invalidEmail = true
                        this.showLoader = false
                    }
                })
            }
        }
    },
    computed: {
        ...mapGetters({
            showPopUpPasswordRecovery: `auth/showPopUpPasswordRecovery`,
            showPopUpPasswordEmail: `auth/showPopUpPasswordEmail`,
            emailSent: 'auth/emailSent',
            reset: 'auth/resetPassword'
        }),
    }
}

